import React from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import '../../../../../assets/scss/theme/_real-estate.scss';
import { EditBranchOfficeForm } from './EditBranchOfficeForm';
import { BranchOfficeForm } from './BranchOfficeForm';

const BranchOfficesData = () => {
  const branchOffices = useSelector(
    state => state.realEstate.branchOfficesArray
  );
  const loadingBranchOffices = useSelector(
    state => state.realEstate.loadingBranchOffices
  );

  const userLogged = useSelector(state => state.login.currentUser);

  if (loadingBranchOffices) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '80vh' }}
      >
        <Spinner
          animation="border"
          style={{
            color: '#2c7be5'
          }}
        />{' '}
      </div>
    );
  }

  return (
    <Row className="g-3">
      {branchOffices.map(branchOffice => (
        <Col xs={12} key={branchOffice.id}>
          {userLogged?.typeOfUser !== 'cucicba' ? (
            <BranchOfficeForm branchOffice={branchOffice} />
          ) : (
            <EditBranchOfficeForm branchOffice={branchOffice} />
          )}
        </Col>
      ))}
    </Row>
  );
};

export default BranchOfficesData;
